import React, { useEffect, useRef, useState } from "react";
import Layout from "../../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../../utils/ToastFile";
import { addTaskLog, updateTaskLog } from "../../../api/TaskApi";
import ReactSelect from "react-select";
import moment from "moment";
import { getAllRoutebyContractor } from "../../../api/RouteApi";
import { Controller } from "react-hook-form";
import { getEmployeeDetails } from "../../../api/EmployeeApi";
import ButtonLoader from "../../../components/ButtonLoader";
import { addLocation } from "../../../api/locationApi";
import { getCurrentLocation } from "../../../utils/getLocation";

const StartTask = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [routes, setRoutes] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const fetched = useRef(false);
  const [isLoading, setIsloading] = useState(false);
  const [isLocationEnable, setIsLocationEnable] = useState(false);

  useEffect(() => {
    reset(state?.taskLog);
    if (fetched.current) return;
    fetched.current = true;
    getRoute();
  }, []);

  const getRoute = async () => {
    await Promise.all([
      getEmployeeDetails(user.id),
      getAllRoutebyContractor(user.tenant_id),
    ])
      .then(([employeeRes, routesRes]) => {
        if (employeeRes.status === 200 && routesRes.status === 200) {
          const employee = employeeRes?.data?.data;
          setIsLocationEnable(
            employee.settings
              ? JSON.parse(employee.settings)?.LocationTracking
              : false,
          );
          if (employee?.routesList && employee?.routesList.length > 0) {
            const options = routesRes?.data?.data?.routes
              .filter((route) => employee.routesList.includes(route._id))
              .map((route) => ({
                value: route._id,
                label: route.routeName,
              }));
            setRoutes(options);
          }
        } else {
          ToastFile("Failed to fetch employee details", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching employee details:", err);
        ToastFile("Error fetching employee details", "error");
      });
  };

  const onSubmit = async (data) => {
    let payload = {
      ...state.taskLog,
      routeInfo: data?.selectedRoute.map((el) => el.value),
    };

    if (isLocationEnable) {
      try {
        const position = await getCurrentLocation();
        const { latitude, longitude } = position.coords;
        setIsloading(true);
        await addTaskLog(payload)
          .then(async (res) => {
            setIsloading(false);
            if (res.status === 201) {
              ToastFile("Task started successfully", "success");
              fetched.current = false;
              const body = {
                taskLog_id: res.data.data.taskLog_id,
                employee: user.id,
                events: "start",
                latitude,
                longitude,
                createdAt: new Date(),
              };

              const response = await addLocation(body);
              if (response.status === 200) {
                console.log("Location added");
              }

              navigate("/mytask");
            } else {
              ToastFile("Failed to start task", "error");
            }
          })
          .catch((err) => {
            console.error("Error starting task:", err);
            ToastFile("Error starting task", "error");
            setIsloading(false);
          });
      } catch (locationError) {
        // Show the specific error message to the user on mobile
        console.error("Location error:", locationError.message);

        if (
          locationError.message.includes("unavailable") ||
          locationError.message.includes("blocked") ||
          locationError.message.includes("denied")
        ) {
          alert(
            "📍 GPS is turned off on your device.\n\n" +
              "Android: Settings → Location → Turn ON\n" +
              "iPhone: Settings → Privacy → Location Services → Turn ON\n\n" +
              "Then come back and try again.",
          );
          // GPS is OFF — guide the user
        } else {
          ToastFile(locationError.message, "error");
        }
      }
    } else {
      setIsloading(true);
      await addTaskLog(payload)
        .then(async (res) => {
          setIsloading(false);
          if (res.status === 201) {
            ToastFile("Task started successfully", "success");
            fetched.current = false;

            navigate("/mytask");
          } else {
            ToastFile("Failed to start task", "error");
          }
        })
        .catch((err) => {
          console.error("Error starting task:", err);
          ToastFile("Error starting task", "error");
          setIsloading(false);
        });
    }
  };

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            Route Information
          </span>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Select Route</Form.Label>
            <div style={{ width: "300px" }}>
              <Controller
                control={control}
                name="selectedRoute"
                rules={{ required: false }}
                render={({ field }) => (
                  <ReactSelect
                    {...field}
                    isMulti
                    className="py-1 rounded-0"
                    options={routes}
                    onChange={(selected) => {
                      field.onChange(selected); // update form value
                    }}
                  />
                )}
              />
            </div>
          </Form.Group>
          <Button variant="primary" type="submit" style={{ minWidth: "98px" }}>
            {isLoading ? (
              <ButtonLoader width="20px" height="20px" />
            ) : (
              "Start Task"
            )}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/mytask")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default StartTask;
